var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification-wrap"},[_c('v-badge',{attrs:{"color":"#f06008","content":"6","overlap":""}},[_c('img',{attrs:{"src":require("@/assets/img/notification-icon.png"),"alt":"notification"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }